// Generated by `bun run mapdata:generate` from packages/map-data/assets/overviews.
// Valve owns these numbers; edit the overview files, not this one.

import type { MapOverview } from '../types';

/** Measured off the shipped images, which the generator requires to be square and uniform. */
export const RADAR_IMAGE_SIZE = 1024;

export const MAP_IDS = [
  'de_ancient',
  'de_anubis',
  'de_cache',
  'de_dust2',
  'de_inferno',
  'de_mirage',
  'de_nuke',
  'de_overpass',
] as const;

export type MapId = (typeof MAP_IDS)[number];

export const MAP_OVERVIEWS: Readonly<Record<MapId, MapOverview>> = {
  de_ancient: {
    id: 'de_ancient',
    posX: -2953,
    posY: 2164,
    scale: 5,
    rotate: 0,
    zoom: 0,
    levels: [
      {
        image: 'de_ancient',
        altitudeMax: 10000,
        altitudeMin: -10000,
      },
    ],
  },
  de_anubis: {
    id: 'de_anubis',
    posX: -2796,
    posY: 3328,
    scale: 5.22,
    rotate: 0,
    zoom: 0,
    levels: [
      {
        image: 'de_anubis',
        altitudeMax: 10000,
        altitudeMin: -10000,
      },
    ],
  },
  de_cache: {
    id: 'de_cache',
    posX: -2000,
    posY: 3250,
    scale: 5.5,
    rotate: 0,
    zoom: 0,
    levels: [
      {
        image: 'de_cache',
        altitudeMax: 10000,
        altitudeMin: -10000,
      },
    ],
  },
  de_dust2: {
    id: 'de_dust2',
    posX: -2476,
    posY: 3239,
    scale: 4.4,
    rotate: 1,
    zoom: 1.1,
    levels: [
      {
        image: 'de_dust2',
        altitudeMax: 10000,
        altitudeMin: -10000,
      },
    ],
  },
  de_inferno: {
    id: 'de_inferno',
    posX: -2087,
    posY: 3870,
    scale: 4.9,
    rotate: 0,
    zoom: 0,
    levels: [
      {
        image: 'de_inferno',
        altitudeMax: 10000,
        altitudeMin: -10000,
      },
    ],
  },
  de_mirage: {
    id: 'de_mirage',
    posX: -3230,
    posY: 1713,
    scale: 5,
    rotate: 0,
    zoom: 0,
    levels: [
      {
        image: 'de_mirage',
        altitudeMax: 10000,
        altitudeMin: -10000,
      },
    ],
  },
  de_nuke: {
    id: 'de_nuke',
    posX: -3453,
    posY: 2887,
    scale: 7,
    rotate: 0,
    zoom: 0,
    levels: [
      {
        image: 'de_nuke',
        altitudeMax: 10000,
        altitudeMin: -495,
      },
      {
        image: 'de_nuke_lower',
        altitudeMax: -495,
        altitudeMin: -10000,
      },
    ],
  },
  de_overpass: {
    id: 'de_overpass',
    posX: -4831,
    posY: 1781,
    scale: 5.2,
    rotate: 0,
    zoom: 0,
    levels: [
      {
        image: 'de_overpass',
        altitudeMax: 10000,
        altitudeMin: -10000,
      },
    ],
  },
};
